import { GA_TRACKING_ID } from "../constants";

const GAService = {
  loadGoogleAnalytics: () => {
    const gaScript = document.createElement("script");
    gaScript.setAttribute("async", "true");
    gaScript.setAttribute(
      "src",
      `https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`
    );

    const gaScript2 = document.createElement("script");
    gaScript2.innerText = `window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag('js', new Date());gtag('config', '${GA_TRACKING_ID}');`;

    document.documentElement?.firstChild?.appendChild(gaScript);
    document.documentElement?.firstChild?.appendChild(gaScript2);
  },
};

export default GAService;
